export default "__VITE_ASSET__DBD58oOk__"